<template>
  <v-container grid-list fluid>
    <v-layout row wrap>
      <v-flex v-if="!shift.userId" xs12 class="mb-2">
        <v-layout row v-if="shift.sunsetAfter" class="mb-2">
          <v-flex>
            <v-datetime-picker
              readonly
              disabled
              v-model="shift.sunsetAfter"
              label="Sunset time (shift will be cancelled if not filled by this time)"
              format="ddd, MMM DD YYYY"
            >
            </v-datetime-picker>
          </v-flex>

          <v-flex xs8>
            {{
              this.$moment(newShiftStart).diff(
                this.$moment(shift.sunsetAfter),
                "days"
              )
            }}
            days from shift start
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex class="mr-2">
            <date-picker
              v-model="newShiftStart"
              type="datetime"
              :time-picker-options="{
                start: '06:00',
                step: '00:15',
                end: '23:45'
              }"
              format="ddd, MMM DD YYYY, h:mma"
              placeholder="Shift Start"
            ></date-picker>
            <span
              v-if="startDateChanged"
              style="color: #19a119; font-size: 12px;"
              >Saved!</span
            >
          </v-flex>
          <v-flex>
            <date-picker
              v-model="newShiftEnd"
              type="datetime"
              :time-picker-options="{
                start: '06:00',
                step: '00:15',
                end: '23:45'
              }"
              format="ddd, MMM DD YYYY, h:mma"
              placeholder="Shift End"
            ></date-picker>
            <span v-if="endDateChanged" style="color: #19a119; font-size: 12px;"
              >Saved!</span
            >
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex class="mr-2">
            <ApiField
              prefix="$"
              label="Bonus"
              storeAction="shifts/update"
              storeUpdate="shifts/updateViewedShift"
              paramName="shift"
              :object="shift"
              fieldName="straight_bonus_amount"
              :storeFieldValue="
                shift.straightBonusAmount
                  ? shift.straightBonusAmount.replace(/\$/, '')
                  : ''
              "
            >
            </ApiField>
          </v-flex>
        </v-layout>

        <v-layout column>
          <v-layout row>
            <v-checkbox
              style="display: inline-block"
              label="Allow New Grads"
              v-model="updateNGShift"
            >
            </v-checkbox>
          </v-layout>
          <v-layout row>
            <v-flex xs4>
              <v-btn
                v-if="ngChanged"
                color="success"
                @click="saveNG"
                :loading="savingNG"
                :disabled="savingNG"
                >Update New Grad Setting</v-btn
              >
              <v-btn
                v-if="ngChanged && !savingNG"
                color="error"
                :loading="savingNG"
                :disabled="savingNG"
                @click="updateNGShift = isNGShift"
                >Discard Change</v-btn
              >
            </v-flex>
          </v-layout>
        </v-layout>

        <v-layout column>
          <span class="subheading">Required Skills</span>
          <v-layout row wrap>
            <v-flex xs4 v-for="skill in skillOptions">
              <v-checkbox
                :label="skill.name"
                :value="skill.id"
                v-model="skillsSelected"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs4>
              <v-btn
                v-if="skillsChanged"
                color="success"
                @click="saveSkills"
                :loading="savingSkills"
                :disabled="savingSkills"
                >Save Skills</v-btn
              >
              <v-btn
                v-if="skillsChanged && !savingSkills"
                color="error"
                :loading="savingSkills"
                :disabled="savingSkills"
                @click="skillsSelected = existingSkills"
                >Discard Skill Changes</v-btn
              >
            </v-flex>
          </v-layout>
        </v-layout>

        <v-layout row>
          <v-flex>
            <ApiField
              fieldType="textarea"
              label="Details"
              storeAction="shifts/update"
              storeUpdate="shifts/updateViewedShift"
              paramName="shift"
              :object="shift"
              fieldName="details"
              :storeFieldValue="shift.details"
            >
            </ApiField>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex v-else>
        <v-flex>
          <p class="subtle">
            This shift has been picked up already. If you would like to make a
            change the assigned employee will need to approve it before it is
            committed.
          </p>
          <p v-if="shiftTooSoon" class="red--text">
            This shift starts within 72 hours. You can only adjust the time by
            six hours or less.
          </p>
        </v-flex>
        <v-flex v-if="!shiftTooSoon">
          <v-layout row>
            <v-flex class="mr-2">
              <v-datetime-picker
                label="New Shift Start"
                v-model="shiftStartRequest"
                timePickerFormat="ampm"
                format="ddd, MMM DD YYYY, h:mma"
                :disabled="changeAlreadyRequested && !updatingRequest"
              ></v-datetime-picker>
            </v-flex>
            <v-flex>
              <v-datetime-picker
                label="New Shift End"
                v-model="shiftEndRequest"
                timePickerFormat="ampm"
                format="ddd, MMM DD YYYY, h:mma"
                :disabled="changeAlreadyRequested && !updatingRequest"
              ></v-datetime-picker>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex class="mr-2">
              <v-text-field
                label="New Bonus"
                v-model="shiftBonusRequest"
                :disabled="changeAlreadyRequested && !updatingRequest"
              >
              </v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex>
              <v-textarea
                label="New Details"
                v-model="shiftDetailsRequest"
                :disabled="changeAlreadyRequested && !updatingRequest"
              >
              </v-textarea>
            </v-flex>
          </v-layout>
          <v-layout row justify-end class="text-xs-right mb-4">
            <v-flex>
              <v-btn
                v-if="changeAlreadyRequested && !updatingRequest"
                @click="updatingRequest = !updatingRequest"
                color="primary"
              >
                Modify requested changes
              </v-btn>
              <v-btn
                flat
                v-if="changeAlreadyRequested && updatingRequest"
                @click="updatingRequest = !updatingRequest"
              >
                cancel
              </v-btn>
              <v-btn
                v-if="!changeAlreadyRequested"
                @click="requestChanges"
                color="success"
              >
                Request Change
              </v-btn>
              <v-btn
                v-if="changeAlreadyRequested && updatingRequest"
                @click="requestChanges"
                :loading="changeRequestApiCallPending"
                :disabled="!updatingRequest"
                color="success"
              >
                Save
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex v-if="shiftTooSoon">
          <v-layout row>
            <v-flex class="mr-2">
              <v-datetime-picker
                label="New Shift Start"
                v-model="shiftStartRequest"
                timePickerFormat="ampm"
                format="ddd, MMM DD YYYY, h:mma"
                :disabled="changeAlreadyRequested && !updatingRequest"
              ></v-datetime-picker>
            </v-flex>
            <v-flex>
              <v-datetime-picker
                label="New Shift End"
                v-model="shiftEndRequest"
                timePickerFormat="ampm"
                format="ddd, MMM DD YYYY, h:mma"
                :disabled="changeAlreadyRequested && !updatingRequest"
              ></v-datetime-picker>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex>
              <v-textarea
                label="New Details"
                v-model="shiftDetailsRequest"
                :disabled="changeAlreadyRequested && !updatingRequest"
              >
              </v-textarea>
            </v-flex>
          </v-layout>
          <v-layout row justify-end class="text-xs-right mb-4">
            <v-flex>
              <v-btn
                v-if="changeAlreadyRequested && !updatingRequest"
                @click="updatingRequest = !updatingRequest"
                color="primary"
              >
                Modify requested changes
              </v-btn>
              <v-btn
                flat
                v-if="changeAlreadyRequested && updatingRequest"
                @click="updatingRequest = !updatingRequest"
              >
                cancel
              </v-btn>
              <v-btn
                v-if="!changeAlreadyRequested"
                @click="requestChanges"
                color="success"
              >
                Request Change
              </v-btn>
              <v-btn
                v-if="changeAlreadyRequested && updatingRequest"
                @click="requestChanges"
                :loading="changeRequestApiCallPending"
                :disabled="!updatingRequest"
                color="success"
              >
                Save
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ApiField from "@/components/base/api-field.vue";
import "vue2-datepicker/index.css";
import DatePicker from "vue2-datepicker";

export default {
  props: ["shift", "user"],

  components: {
    ApiField,
    DatePicker
  },

  created() {
    this.setUp();
  },

  data() {
    return {
      endDateChanged: false,
      startDateChanged: false,
      updateNGShift: this.shift.newGradAllowed,
      savingNG: false,
      skillOptions: [],
      skillsSelected: [],
      savingSkills: false,
      shiftDetailsRequest: this.shift.proposedDetails || this.shift.details,
      shiftStartRequest: this.shift.proposedStartDatetime
        ? this.$moment(this.shift.proposedStartDatetime).toDate()
        : this.$moment(this.shift.startDatetime).toDate(),
      shiftEndRequest: this.shift.proposedEndDatetime
        ? this.$moment(this.shift.proposedEndDatetime).toDate()
        : this.$moment(this.shift.endDatetime).toDate(),
      shiftBonusRequest:
        this.shift.proposedStraightBonusAmount > 0
          ? this.shift.proposedStraightBonusAmount
          : this.shift.straightBonusAmount.replace(/\$/, ""),
      updatingRequest: false,
      changeRequestApiCallPending: false
    };
  },

  computed: {
    existingSkills() {
      return this.shift.requiredSkills.map(s => s.id);
    },
    skillsChanged() {
      // Any difference between the starting skills and the selected checkboxes
      return _.xor(this.skillsSelected, this.existingSkills).length > 0;
    },

    shiftTooSoon() {
      if (
        this.$moment(this.shift.startDatetime).isBefore(
          this.$moment().add(72, "hours")
        )
      ) {
        return true;
      } else {
        return false;
      }
    },

    newShiftStart: {
      get: function() {
        return this.$moment(this.shift.startDatetime).toDate();
      },
      set: function(newValue) {
        if (!newValue) {
          return;
        }

        this.startDateChanged = true;

        this.$store.dispatch("shifts/update", {
          id: this.shift.id,
          shift: {
            start_datetime: newValue
          }
        });

        this.successClear = setInterval(() => {
          this.startDateChanged = false;
        }, 1500);
      }
    },

    newShiftEnd: {
      get: function() {
        return this.$moment(this.shift.endDatetime).toDate();
      },
      set: function(newValue) {
        if (!newValue) {
          return;
        }

        this.endDateChanged = true;

        this.$store.dispatch("shifts/update", {
          id: this.shift.id,
          shift: {
            end_datetime: newValue
          }
        });

        this.successClear = setInterval(() => {
          this.endDateChanged = false;
        }, 1500);
      }
    },

    changeAlreadyRequested() {
      if (this.shift.changesProposed) {
        return true;
      } else {
        return false;
      }
    },
    isNGShift() {
      return this.shift.newGradAllowed;
    },
    ngChanged() {
      return this.updateNGShift != this.isNGShift;
    }
  },

  methods: {
    setUp() {
      this.$store.dispatch("serviceRequest/getSkills").then(res => {
        this.skillOptions = res;
      });
      this.skillsSelected = this.shift.requiredSkills.map(s => s.id);
    },

    saveNG() {
      this.savingNG = true;
      this.$store
        .dispatch("shifts/update", {
          id: this.shift.id,
          shift: {
            new_grads_allowed: this.updateNGShift
          }
        })
        .then(res => {
          const message = `New Grad settings saveed`;
          this.$store.dispatch(
            "global/showSnackbarSuccess",
            { message: message },
            { root: true }
          );
        })
        .catch(err => {
          const message = `Something went wrong updating the New Grad settings`;
          this.$store.dispatch(
            "global/showSnackbarError",
            { message: message },
            { root: true }
          );
        })
        .finally(res => {
          this.savingNG = false;
        });
    },

    saveSkills() {
      this.savingSkills = true;
      this.$store
        .dispatch("shifts/update", {
          id: this.shift.id,
          shift: {
            required_skill_ids: this.skillsSelected
          }
        })
        .then(res => {
          const message = `Required Skills updated`;
          this.$store.dispatch(
            "global/showSnackbarSuccess",
            { message: message },
            { root: true }
          );
        })
        .catch(err => {
          const message = `Something went wrong updating the skills`;
          this.$store.dispatch(
            "global/showSnackbarError",
            { message: message },
            { root: true }
          );
        })
        .finally(res => {
          this.savingSkills = false;
        });
    },

    requestChanges() {
      let startHoursDiff = this.$moment
        .duration(
          this.$moment(this.shiftStartRequest).diff(this.shift.startDatetime)
        )
        .asHours();

      let endHoursDiff = this.$moment
        .duration(
          this.$moment(this.shiftEndRequest).diff(this.shift.endDatetime)
        )
        .asHours();

      if (Math.abs(startHoursDiff) > 6 || Math.abs(endHoursDiff) > 6) {
        const message = `The shift time cannot change by more than 6 hours!`;
        this.$store.dispatch(
          "global/showSnackbarError",
          { message: message },
          { root: true }
        );
        return;
      }

      this.changeRequestApiCallPending = true;
      this.$store
        .dispatch("shifts/update", {
          id: this.shift.id,
          shift: {
            proposed_start_datetime: this.shiftStartRequest,
            proposed_end_datetime: this.shiftEndRequest,
            proposed_straight_bonus_amount: this.shiftBonusRequest,
            proposed_details: this.shiftDetailsRequest
          }
        })
        .then(res => {
          const message = `Changes requested! The employee has been notified`;
          this.$store.dispatch(
            "global/showSnackbarSuccess",
            { message: message },
            { root: true }
          );
        })
        .finally(res => {
          this.updatingRequest = false;
          this.changesProposed = true;
          this.changeRequestApiCallPending = false;
        });
    }
  }
};
</script>
